import { TypedUseSelectorHook, useSelector } from 'react-redux';

import type { UserRole } from 'shared-types';
import type { ReduxRootState } from 'types';

type UserRoleOptions = Exclude<UserRole, 'group-admin' | 'supervisor'>;

const useAppSelector: TypedUseSelectorHook<ReduxRootState<UserRoleOptions>> =
  useSelector;

// We are defaulting here to vuoadmin as it is the most broadly available role
// however, we eventually want to remove the default and specify the role explicitly
// when we call the hook, to properly handle what is available in the config for the user
const useReduxState = <T extends UserRoleOptions = 'vuoadmin'>() => {
  return useAppSelector((state: ReduxRootState<T>) => state);
};

export default useReduxState;
